// 浮动聊天窗口样式

export const WIDGET_STYLES = `
/* 样式重置和命名空间 */
.floating-chat-widget * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* 浮动按钮 */
.floating-chat-button {
  position: fixed;
  z-index: 9999;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.floating-chat-button[data-position="bottom-right"] {
  bottom: 20px;
  right: 20px;
}

.floating-chat-button[data-position="bottom-left"] {
  bottom: 20px;
  left: 20px;
}

.floating-chat-button[data-position="top-right"] {
  top: 20px;
  right: 20px;
}

.floating-chat-button[data-position="top-left"] {
  top: 20px;
  left: 20px;
}

.floating-chat-button .button-icon {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  pointer-events: none;
}

.floating-chat-button:hover .button-icon {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.floating-chat-button:active .button-icon {
  transform: scale(0.95);
}

.floating-chat-button svg,
.floating-chat-button img {
  width: 60%;
  height: 60%;
  fill: white;
  pointer-events: none;
}

/* 未读消息徽章 */
.floating-chat-button .unread-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 20px;
  height: 20px;
  background: #ff4d4f;
  color: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  padding: 0 6px;
  box-shadow: 0 2px 8px rgba(255, 77, 79, 0.4);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* 全局注入的辅助样式，用于全屏时禁用宿主滚动 */
body.floating-chat-fullscreen-mode {
  overflow: hidden !important;
}

/* 聊天窗口 */
.floating-chat-window {
  position: fixed;
  z-index: 2147483647; /* 使用 CSS 允许的最大 z-index 值 */
  background: white;
  border-radius: 12px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
}

.floating-chat-window.is-fullscreen {
  width: 100vw !important;
  height: 100vh !important;
  top: 0 !important;
  left: 0 !important;
  bottom: 0 !important;
  right: 0 !important;
  border-radius: 0;
  transform: translate(0, 0) !important;
  z-index: 2147483647 !important;
}

.floating-chat-window[data-position="bottom-right"] {
  bottom: 20px;
  right: 20px;
}

.floating-chat-window[data-position="bottom-left"] {
  bottom: 20px;
  left: 20px;
}

.floating-chat-window[data-position="top-right"] {
  top: 20px;
  right: 20px;
}

.floating-chat-window[data-position="top-left"] {
  top: 20px;
  left: 20px;
}

.floating-chat-window[data-state="closed"] {
  display: none;
}

.floating-chat-window[data-state="opening"] {
  animation: floatIn 250ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
  transform-origin: bottom right;
}

.floating-chat-window[data-state="closing"] {
  animation: floatOut 200ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
  transform-origin: bottom right;
}

.floating-chat-window.is-fullscreen[data-state="opening"] {
  animation: fadeIn 250ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.floating-chat-window.is-fullscreen[data-state="closing"] {
  animation: fadeOut 200ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes floatIn {
  0% {
    opacity: 0;
    transform: scale(0.85) translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes floatOut {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.85) translateY(20px);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* 窗口标题栏 */
.floating-chat-window .window-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: white;
}

.floating-chat-window[data-theme="dark"] .window-header {
  background: #1f1f1f;
  border-bottom-color: #333;
}

.floating-chat-window .window-title {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  flex: 1;
}

.floating-chat-window[data-theme="dark"] .window-title {
  color: #fff;
}

.floating-chat-window .window-controls {
  display: flex;
  gap: 8px;
}

.floating-chat-window .window-controls button {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #8c8c8c;
  font-size: 20px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  line-height: 1;
}

.floating-chat-window .window-controls button:hover {
  background: #f5f5f5;
  color: #262626;
}

.floating-chat-window[data-theme="dark"] .window-controls button:hover {
  background: #333;
  color: #fff;
}

.floating-chat-window .window-controls .btn-refresh:active {
  animation: refresh-spin 0.6s ease-in-out;
}

@keyframes refresh-spin {
  to {
    transform: rotate(360deg);
  }
}

/* 窗口主体 */
.floating-chat-window .window-body {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.floating-chat-window.is-fullscreen .window-body {
  overflow-y: auto;
}

/* 自定义滚动条样式，特别是针对全屏状态 */
.floating-chat-window.is-fullscreen .window-body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.floating-chat-window.is-fullscreen .window-body::-webkit-scrollbar-track {
  background: transparent;
}

.floating-chat-window.is-fullscreen .window-body::-webkit-scrollbar-thumb {
  background: rgba(140, 140, 140, 0.4);
  border-radius: 4px;
}

.floating-chat-window.is-fullscreen .window-body::-webkit-scrollbar-thumb:hover {
  background: rgba(140, 140, 140, 0.6);
}

.floating-chat-window[data-theme="dark"].is-fullscreen .window-body::-webkit-scrollbar-thumb {
  background: rgba(160, 160, 160, 0.4);
}

.floating-chat-window[data-theme="dark"].is-fullscreen .window-body::-webkit-scrollbar-thumb:hover {
  background: rgba(160, 160, 160, 0.6);
}

.floating-chat-window .window-body iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* 加载状态 */
.floating-chat-window .loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
}

.floating-chat-window[data-theme="dark"] .loading-overlay {
  background: rgba(31, 31, 31, 0.9);
}

.floating-chat-window .loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f0f0f0;
  border-top-color: #1890ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.floating-chat-window .loading-text {
  font-size: 14px;
  color: #8c8c8c;
}

/* 认证错误状态 */
.floating-chat-window .auth-error-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.floating-chat-window[data-theme="dark"] .auth-error-overlay {
  background: rgba(31, 31, 31, 0.95);
}

.floating-chat-window .error-content {
  text-align: center;
  max-width: 300px;
}

.floating-chat-window .error-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.floating-chat-window .error-message {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 8px;
}

.floating-chat-window[data-theme="dark"] .error-message {
  color: #fff;
}

.floating-chat-window .error-hint {
  font-size: 14px;
  color: #8c8c8c;
}

.floating-chat-window[data-theme="dark"] .error-hint {
  color: #a0a0a0;
}

/* 响应式设计 */
@media (max-width: 767px) {
  .floating-chat-button {
    bottom: 16px !important;
    right: 16px !important;
  }
  
  .floating-chat-window {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 100% !important;
    border-radius: 0 !important;
    max-width: none !important;
    max-height: none !important;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .floating-chat-window {
    width: 360px !important;
    height: 500px !important;
  }
}

/* 暗色主题 */
.floating-chat-window[data-theme="dark"] {
  background: #1f1f1f;
}

.floating-chat-window[data-theme="dark"] .loading-spinner {
  border-color: #333;
  border-top-color: #1890ff;
}

.floating-chat-window[data-theme="dark"] .loading-text {
  color: #a0a0a0;
}

/* ========== ChatModal 全屏居中弹窗 ========== */
.chat-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2147483646;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.25s ease, visibility 0.25s ease;
  padding: 20px;
}

.chat-modal-overlay.is-visible {
  opacity: 1;
  visibility: visible;
}

.chat-modal-container {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 800px;
  height: 85vh;
  max-height: 700px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: translateY(20px);
  transition: transform 0.25s ease;
}

.chat-modal-overlay.is-visible .chat-modal-container {
  transform: translateY(0);
}

.chat-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.chat-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
}

.chat-modal-close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #8c8c8c;
  font-size: 16px;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  line-height: 1;
}

.chat-modal-close-btn:hover {
  background: #f5f5f5;
  color: #262626;
}

.chat-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.chat-modal-message {
  max-width: 85%;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.65;
  word-break: break-word;
}

.chat-modal-message--user {
  align-self: flex-end;
  background: #1890ff;
  color: #fff;
  border-bottom-right-radius: 4px;
}

.chat-modal-message--ai {
  align-self: flex-start;
  background: #f5f5f5;
  color: #262626;
  border-bottom-left-radius: 4px;
}

.chat-modal-message--error {
  align-self: flex-start;
  background: #fff2f0;
  color: #cf1322;
  border: 1px solid #ffccc7;
  border-radius: 8px;
}

.chat-modal-ai-content {
  font-size: 14px;
  line-height: 1.7;
}

.chat-modal-ai-content code {
  background: rgba(0, 0, 0, 0.06);
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 13px;
}

.chat-modal-ai-content strong {
  font-weight: 600;
}

.chat-modal-ai-content a {
  color: #1890ff;
  text-decoration: underline;
  word-break: break-all;
}

.chat-modal-ai-content a:hover {
  color: #096dd9;
}

/* 思考过程区域（始终可见，流式输出） */
.chat-modal-reasoning {
  align-self: flex-start;
  max-width: 85%;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  color: #8c6d00;
}

.chat-modal-reasoning-label {
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 4px;
}

.chat-modal-reasoning-arrow {
  font-size: 10px;
  transition: transform 0.2s;
}

.chat-modal-reasoning.collapsed .chat-modal-reasoning-arrow {
  transform: rotate(-90deg);
}

.chat-modal-reasoning.collapsed .chat-modal-reasoning-content {
  display: none;
}

.chat-modal-reasoning-content {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  line-height: 1.6;
}

/* 加载指示器 */
.chat-modal-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  color: #8c8c8c;
  font-size: 13px;
  align-self: flex-start;
}

.chat-modal-spinner {
  width: 20px;
  height: 20px;
  border: 2.5px solid #f0f0f0;
  border-top-color: #1890ff;
  border-radius: 50%;
  animation: chat-modal-spin 0.7s linear infinite;
}

@keyframes chat-modal-spin {
  to { transform: rotate(360deg); }
}

/* 暗色主题 */
.chat-modal-overlay[data-theme="dark"] .chat-modal-container {
  background: #1f1f1f;
}

.chat-modal-overlay[data-theme="dark"] .chat-modal-header {
  border-bottom-color: #333;
}

.chat-modal-overlay[data-theme="dark"] .chat-modal-title {
  color: #fff;
}

.chat-modal-overlay[data-theme="dark"] .chat-modal-close-btn {
  color: #a0a0a0;
}

.chat-modal-overlay[data-theme="dark"] .chat-modal-close-btn:hover {
  background: #333;
  color: #fff;
}

.chat-modal-overlay[data-theme="dark"] .chat-modal-message--ai {
  background: #2a2a2a;
  color: #e0e0e0;
}

.chat-modal-overlay[data-theme="dark"] .chat-modal-ai-content code {
  background: rgba(255, 255, 255, 0.08);
}

.chat-modal-overlay[data-theme="dark"] .chat-modal-reasoning {
  background: #2a2614;
  border-color: #5c4a1f;
  color: #c4a030;
}

.chat-modal-overlay[data-theme="dark"] .chat-modal-spinner {
  border-color: #333;
  border-top-color: #1890ff;
}

/* 底部 AI 生成提示 */
.chat-modal-disclaimer {
  text-align: center;
  padding: 8px 20px 12px;
  font-size: 12px;
  color: #bfbfbf;
  flex-shrink: 0;
  border-top: 1px solid #f5f5f5;
}

.chat-modal-overlay[data-theme="dark"] .chat-modal-disclaimer {
  color: #595959;
  border-top-color: #2a2a2a;
}

/* 移动端适配 */
@media (max-width: 767px) {
  .chat-modal-overlay {
    padding: 0;
  }

  .chat-modal-container {
    max-width: 100%;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }
}
`;
